import {
  Box,
  useTheme,
  Typography,
  Paper,
  Divider,
  Chip,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import PaymentStatusChanger from "./status-chenger/PaymentStatusChanger";
import { Styles } from "./styles";

const AddBalanceReviewPage = ({ data = {}, refetch }) => {
  const [formData, setFormData] = useState(data);
  const theme = useTheme();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };



  // Section heading style
  const sectionHeadingStyle = {
    fontWeight: 600,
    color: theme.palette.primary.dark,

    p: 1.5,
    borderRadius: "4px 4px 0 0",
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    mb: 2,
  };

  return (
    <Styles>
      <Box sx={{ width: "100%", p: 2 }}>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
          {/* Main Order Header */}
          <Box
            sx={{
              mb: 3,
              backgroundColor: theme.palette.grey[100],
              p: 2,
              borderRadius: 1,
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              sx={{ fontWeight: 600, color: theme.palette.primary.main }}
            >
              Add Balance Request #{data.id || "N/A"}
            </Typography>
            <Chip
              label={data.status === "DRAFT" ? 'PENDING':data.status}
              color={
                data.status === "DRAFT"
                  ? "warning"
                  : data.status === "ACCEPTED"
                  ? "success"
                  : "error"
              }
              sx={{ mt: 1 }}
            />
          </Box>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={3}>
            {/* Customer Information */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ height: "100%" }}>
                <Typography variant="h6" sx={sectionHeadingStyle}>
                  Customer Information
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Name
                    </Typography>
                    <Typography>{data.user?.name || "N/A"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Panel URL
                    </Typography>
                    <Typography sx={{ wordBreak: "break-all" }}>
                      {data.panel?.smmpanel_url || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Order Details */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ height: "100%" }}>
                <Typography variant="h6" sx={sectionHeadingStyle}>
                  Add Balance Request Details
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Created At
                    </Typography>
                    <Typography>{formatDate(data.created_at)}</Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Payment Information */}
            <Grid item xs={12}>
              <Paper elevation={0}>
                <Typography variant="h6" sx={sectionHeadingStyle}>
                  Payment Information
                </Typography>
                <Box sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Method
                      </Typography>
                      <Typography sx={{ textTransform: "capitalize" }}>
                        {data.payment_method || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Amount
                      </Typography>
                      <Typography>${data.amount || "0.00"}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>

            {/* Payment Document */}
            {data.payment_document && (
              <Grid item xs={12}>
                <Paper elevation={0}>
                  <Typography variant="h6" sx={sectionHeadingStyle}>
                    Payment Document
                  </Typography>
                  <Box
                    sx={{
                      p: 2,
                      maxWidth: 400,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 1,
                    }}
                  >
                    <img
                      src={data.payment_document}
                      alt="Payment Document"
                      style={{ width: "100%", height: "auto", borderRadius: 4 }}
                    />
                  </Box>
                </Paper>
              </Grid>
            )}

            {/* Payment Note */}
            {data.payment_note && (
              <Grid item xs={12}>
                <Paper elevation={0}>
                  <Typography variant="h6" sx={sectionHeadingStyle}>
                    Payment Note
                  </Typography>
                  <Box sx={{ p: 2 }}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        backgroundColor: theme.palette.background.default,
                      }}
                    >
                      <Typography>{data.payment_note}</Typography>
                    </Paper>
                  </Box>
                </Paper>
              </Grid>
            )}

            {
              data.status !== 'ACCEPTED' &&
              <Grid item xs={12}>
                <Paper elevation={0}>
                  <Typography
                      variant="h6"
                      sx={{
                        ...sectionHeadingStyle,
                        backgroundColor: theme.palette.warning.light,
                        borderBottom: `2px solid ${theme.palette.warning.main}`,
                      }}
                  >
                    Update  Status
                  </Typography>
                  <Box sx={{ p: 2 }}>
                    <PaymentStatusChanger
                        data={data}
                        setData={setFormData}
                        rowsPerPage={1}
                        currentPage={1}
                        source={"Order"}
                        refetch={refetch}
                    />
                  </Box>
                </Paper>
              </Grid>
            }


          </Grid>
        </Paper>
      </Box>
    </Styles>
  );
};

export default AddBalanceReviewPage;
